import VueStore from "vue-j-store";

export default new VueStore({
    state:{
        keyword:"",
        list:[],
        scrollTop:0
    },  
    actions:{
       change(context){
           context.commit("clear");
           context.triggerChange&&context.triggerChange();
       }
    },
    mutations:{
        clear:function(state){
            state.list.length=0;
        },
        push:function(state,data){
            state.list.push(...data);
        }
    }
});


// WEBPACK FOOTER //
// ./src/components/search-form/store.js